var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFDE17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5718 17.6353L32.4608 19.4316L30.0027 17.9976L29.99 15.1518L33.1012 13.3556C33.2879 13.2477 33.2901 12.9781 33.1057 12.8665C31.2816 11.765 28.9277 11.6673 26.9575 12.8273C24.6827 14.1666 23.6014 16.8582 24.1639 19.344L12.9304 30.5773C11.6899 31.8178 11.6899 33.8292 12.9304 35.07C14.1709 36.3104 16.1822 36.3104 17.423 35.07L28.6504 23.8426C30.0795 24.1735 31.6323 23.9858 33.003 23.1942C34.9638 22.0622 36.0394 19.9904 35.9979 17.8762C35.9933 17.6608 35.7587 17.5275 35.5718 17.6353Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairIcon);
export default __webpack_public_path__ + "static/media/repair-icon.7a7f32a8c46f78f32810b9be5c26b9d7.svg";
export { ForwardRef as ReactComponent };